import React from "react";
import { Toaster } from "react-hot-toast";

const ToastProvider = () => {
  return (
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 3500, // slightly longer so user notices
        style: {
          background: "#e0f2fe", // light blue
          color: "#1e40af", // dark blue text
          borderRadius: "16px",
          padding: "16px 24px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
          fontFamily: "Inter, sans-serif",
          fontSize: "16px",
          fontWeight: 500,
        },
        success: {
          iconTheme: {
            primary: "#2563eb", // medium blue
            secondary: "#fff",
          },
          style: {
            borderLeft: "6px solid #2563eb",
          },
        },
        error: {
          iconTheme: {
            primary: "#ef4444", // keep red for errors
            secondary: "#fff",
          },
          style: {
            borderLeft: "6px solid #ef4444",
          },
        },
      }}
    />
  );
};

export default ToastProvider;
